// extracted by mini-css-extract-plugin
export default {"overlay":"Iy-z","bodyOpen":"Jy-z","content":"Ky-z","header":"Ly-z","close":"My-z","closeNoHeading":"Ny-z"};